import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() => ({
  bottomSpacing: {
    paddingBottom: 10
  },
  gridItem: {
    paddingBottom: 10,
    width: '100%'
  }
}));

export default useStyles;
